import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

export interface ResourceRefreshOptions { full?: boolean }

@Injectable({ providedIn: 'root' })
export class ResourceRefreshService {
  private subjects = new Map<string, Subject<ResourceRefreshOptions>>();

  notify(key: string, opts: ResourceRefreshOptions = { full: false }): void {
// $#$    // /* alert(`Notifying refresh for ${key} with options: ${JSON.stringify(opts) */}`);
    if (!this.subjects.has(key)) this.subjects.set(key, new Subject<ResourceRefreshOptions>());
    this.subjects.get(key)!.next(opts);
  }

  onRefresh(key: string): Observable<ResourceRefreshOptions> {
// $#$    // /* alert(`Subscribing to refresh for ${key}`); */
    if (!this.subjects.has(key)) this.subjects.set(key, new Subject<ResourceRefreshOptions>());
    return this.subjects.get(key)!.asObservable();
  }
}
